// Any error → the i18n key of ONE plain sentence (app review B5). Raw database
// text ("new row violates row-level security policy…") and server codes
// ("stripe_error") never reach the screen. A plan past its trial is read-only
// in RLS, so the same refusal means "subscribe" there and "not allowed" else.

// Server codes that tell the person something they can act on. Every other
// code falls through to the generic sentence.
const CODE_KEYS = {
  seats_below_usage: 'billing.errSeatsBelow',
  already_subscribed: 'err.alreadySubscribed',
  no_active_subscription: 'err.noSubscription',
  admin_only: 'err.adminOnly',
  invalid_seats: 'err.invalidSeats',
};

const NETWORK = /failed to fetch|networkerror|network request failed|load failed|fetch failed|FunctionsFetchError|internet_disconnected/i;
const DENIED = /row-level security|permission denied/i;

// err: an Error, a supabase error ({ code, message }), or a bare code string.
export function plainErrorKey(err, { readOnly = false, online = true } = {}) {
  const code = typeof err === 'string' ? err : String(err?.code ?? '');
  const msg = typeof err === 'string' ? err : `${err?.name ?? ''} ${err?.message ?? ''}`;
  const known = CODE_KEYS[code] || CODE_KEYS[String(err?.message ?? '').trim()];
  if (known) return known;
  if (!online || NETWORK.test(msg)) return 'err.offline';
  if (code === '42501' || DENIED.test(msg)) return readOnly ? 'err.readOnly' : 'err.denied';
  return 'err.generic';
}
